import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Order, OrderPrintMeal } from "../components/Menu/Menu";
import { separateMealsFromOrder } from "./utils";

export async function exportStickersToPDF(ordersData: Order[]) {
    const separatedMeals = separateMealsFromOrder(ordersData);

    // Chunk array into rows of size 3 (3 stickers per row)
    function chunkArray(array: OrderPrintMeal[], size: number): OrderPrintMeal[][] {
        const result: OrderPrintMeal[][] = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    }

    const chunkedMeals = chunkArray(separatedMeals, 3);

    const PAGE_HEIGHT = 297; // mm A4 height
    const ROW_HEIGHT = (PAGE_HEIGHT - 2 * 12) / 7; // approx sticker height in mm (for pagination)

    // Paginate rows so pages don't overflow
    const paginateRows = (rows: OrderPrintMeal[][]) => {
        const pages: OrderPrintMeal[][][] = [];
        let currentPage: OrderPrintMeal[][] = [];
        let currentHeight = 0;

        rows.forEach((row) => {
            if (currentHeight + ROW_HEIGHT > PAGE_HEIGHT) {
                pages.push(currentPage);
                currentPage = [];
                currentHeight = 0;
            }
            currentPage.push(row);
            currentHeight += ROW_HEIGHT;
        });

        if (currentPage.length > 0) {
            pages.push(currentPage);
        }
        return pages;
    };

    const paginatedChunks = paginateRows(chunkedMeals);

    const PDF_WIDTH = 595; // points for A4 width
    const scale = 3; // lower scale for smaller canvas

    const pdf = new jsPDF("portrait", "pt", "a4");

    // Create hidden container for rendering pages one by one
    const input = document.createElement("div");
    input.style.position = "absolute";
    input.style.top = "-10000px";
    document.body.appendChild(input);

    for (let pageIndex = 0; pageIndex < paginatedChunks.length; pageIndex++) {
        const page = paginatedChunks[pageIndex];
        input.innerHTML = `
      <table style="width: 210mm; height: 297mm; padding: 12mm 8mm;">
        <tbody>
          ${paginatedChunks[pageIndex]
                .map(
                    (mealChunk, rowIndex) => `
                <tr style="display: flex;">
                  ${mealChunk
                            .map(
                                (separatedMeal) => `
                    <td style="padding: 35px; width: 264.6px; height: 154.9px; box-sizing: border-box; ${separatedMeal ? "" : "background: #fff;"
                                    }">
                      ${separatedMeal
                                        ? `
                        <div style="font-size: 16px; font-weight: bold;">${separatedMeal.user}</div>
                        <div style="padding: 3px 0; font-size: 12px; border-bottom: 1px solid #000;">${separatedMeal.customer}</div>
                        <div style="padding-top: 3px; font-size: 12px;">${separatedMeal.meal}</div>
                      `
                                        : `<div style="width: 100%; height: 100%;"></div>`
                                    }
                    </td>
                  `
                            )
                            .join("")}
                </tr>
              `
                )
                .join("")}
        </tbody>
      </table>
    `;

        // Allow the browser to render the DOM
        await new Promise((r) => setTimeout(r, 100));

        // Render the current page container to canvas
        const canvas = await html2canvas(input, { scale });

        // Convert canvas to JPEG with quality 0.4 for compression
        const imgData = canvas.toDataURL("image/jpeg", 0.4);

        const imgWidth = PDF_WIDTH;
        const imgHeight = (canvas.height * PDF_WIDTH) / canvas.width;

        if (pageIndex > 0) pdf.addPage();

        pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
    }

    document.body.removeChild(input);

    pdf.save("orders-stickers.pdf");
}